/**
 * CloudFront 이미지 리사이징 유틸리티
 * mfimage.s3.amazonaws.com, genesis.missionfund.org 등 도메인을 CloudFront로 치환하고,
 * ?d=가로x세로 형식으로 크기 지정 시 축소된 이미지를 빠르게 로드합니다.
 *
 * @example
 * - 원본: https://mfimage.s3.amazonaws.com/OMF/projects/xxx.png
 * - 원본: https://genesis.missionfund.org:8282/OMF/projects/xxx.png
 * - 축소: getCloudFrontImageUrl(url, '400x0') → 400px 너비, 비율 유지
 * - 고정: getCloudFrontImageUrl(url, '400x300') → 400x300 크기
 */

const S3_IMAGE_DOMAIN = 'https://mfimage.s3.amazonaws.com';
const CLOUDFRONT_DOMAIN = 'https://d3c7xurkwyn1aa.cloudfront.net';

/**
 * OMF 이미지 URL을 CloudFront URL로 변환하고, 선택적으로 리사이즈 파라미터를 추가합니다.
 * mfimage.s3.amazonaws.com, genesis.missionfund.org, /OMF/ 상대경로 등 지원
 * @param url - 원본 이미지 URL
 * @param dimensions - '가로x세로' (예: '400x300') 또는 '가로x0' (가로만 맞추고 세로 비율 유지)
 * @returns 변환된 URL. OMF 경로가 아니면 원본 반환
 */
export function getCloudFrontImageUrl(url: string | undefined | null, dimensions?: string): string {
  const trimmed = String(url ?? '').trim();
  if (!trimmed) return '';

  let path = '';
  if (trimmed.startsWith(S3_IMAGE_DOMAIN + '/')) {
    path = trimmed.slice(S3_IMAGE_DOMAIN.length);
  } else if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const u = new URL(trimmed);
      if (u.pathname.startsWith('/OMF/')) {
        path = u.pathname;
      } else {
        return trimmed;
      }
    } catch {
      return trimmed;
    }
  } else if (trimmed.startsWith('/OMF/')) {
    path = trimmed;
  } else {
    return trimmed;
  }

  const cloudFrontBase = CLOUDFRONT_DOMAIN + path;
  if (!dimensions) return cloudFrontBase;
  const sep = cloudFrontBase.includes('?') ? '&' : '?';
  return `${cloudFrontBase}${sep}d=${dimensions}`;
}

/** 프로젝트/소식 카드 썸네일용 기본 크기 (가로 400px, 세로 비율 유지) */
export const THUMBNAIL_DIMENSIONS = '400x0';

/** 본문/스토리 내 이미지용 크기 (가로 800px, 세로 비율 유지) */
export const CONTENT_IMAGE_DIMENSIONS = '800x0';
